import {call, put, select, takeEvery} from "redux-saga/effects";
import {onAssignMortgageProvider, onFetchAvailableProducts} from "../Root/Root.saga";
import {ProvinceSelectPagePayload, submit} from "./ProvinceSelectPage.action";
import {WithPayload} from "types/basic";
import {
  AppRouteUrl,
  ResidentialApplicationBasicInfoRequest,
} from "@pinch-financial/pinch-ui-components";
import {saveBasicInfo} from "store/actions/applicantMeta.action";
import {
  getConsolidatedBasicInfo,
  getMortgageProviderIdFromAppOrSelected,
} from "store/selectors/basicInfo";
import {ResidentialApplicationBasicInfoResponse} from "types/dto/residentialApplicationBasicInfoResponse";
import {
  getActiveRouteSequence,
  getPreviousUrlFromHistory,
} from "~/store/selectors/navigationController";
import {getDefaultProviderId} from "~/store/selectors/whitelabel";

export function* onSubmit({
  payload: {selectedProvince, navigate, onNextPage},
}: WithPayload<ProvinceSelectPagePayload>) {
  const currentMortgageProviderId: string = yield select(getMortgageProviderIdFromAppOrSelected);
  const currentDefaultProviderId: string = yield select(getDefaultProviderId);
  const currentProviderId = currentMortgageProviderId || currentDefaultProviderId;
  const basicInfo: ResidentialApplicationBasicInfoResponse = yield select(getConsolidatedBasicInfo);

  const basicInfoRequest: Partial<ResidentialApplicationBasicInfoRequest> = {
    mortgageDetails: {
      ...basicInfo?.mortgageDetails,
      province: selectedProvince,
    },
  };
  yield put(saveBasicInfo(basicInfoRequest));

  yield call(onFetchAvailableProducts, navigate);
  yield call(onAssignMortgageProvider);
  const previousUrl: AppRouteUrl = yield select(getPreviousUrlFromHistory);
  if (previousUrl === AppRouteUrl.SIGN_UP) {
    const activeRouteSequence: AppRouteUrl[] = yield select(getActiveRouteSequence);

    const newMortgageProviderId: string = yield select(getMortgageProviderIdFromAppOrSelected);
    const newDefaultProviderId: string = yield select(getDefaultProviderId);
    const newProviderId = newMortgageProviderId || newDefaultProviderId;
    if (
      !activeRouteSequence.includes(AppRouteUrl.BANK_OR_BROKER) ||
      newProviderId == currentProviderId
    ) {
      yield call(navigate, AppRouteUrl.SIGN_UP);
    } else {
      yield call(navigate, AppRouteUrl.BANK_OR_BROKER);
    }
  } else {
    onNextPage?.();
  }
}

export default function* provinceSelectPageSaga() {
  yield takeEvery(submit, onSubmit);
}
